import { Collection } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { BaseSchemaModifierTransformation } from './base-schema-modifier-transformation';
import { ExpressionBasedColumn } from './expression-based.column';
import { convertColumnRefToDataFlowColumn, IDataFlowArguments, convertParametersToArguments, convertCacheSinksToArguments } from './dataflow-expression-utilities';
import { DataFlowExpressionFunctions } from './dataflow-expression-functions';

import { DataFlowExpression } from './dataflowexpression';
import { DataFlowFunctionArgument } from 'app/model/dataflow/dataflow-function-argument';
import { updateIdentifiers, asyncUpdateIdentifiers } from './dataflow-expression-update-identifiers';
import { ExpressionBasedColumnPattern } from './expression-based.column.pattern';
import { GlobalVariables } from 'app/services/globals';

@Metamodel.model({
    name: 'basegroupbytransformation', // As this is abstract this will never be used
    abstract: true
})
export abstract class BaseGroupByTransformation extends BaseSchemaModifierTransformation {

    @Metamodel.attribute({
        display: stringResources.AggregateTransformationGroupByColumn,
        type: ExpressionBasedColumn.MODEL,
        collection: Collection.Array,
        constraint: {
            unique: true,
            minOccurs: 0
        }
    })
    public groupByColumns: ExpressionBasedColumn[] = [];

    public addColumn(columnPattern?: ExpressionBasedColumnPattern, index?: number): ExpressionBasedColumn {
        const expColumn = super.addColumn(columnPattern, index);
        expColumn.dataFlowExpression.setRequiredFunctions(DataFlowExpressionFunctions.AGGREGATE_FUNCTIONS, stringResources.NoAggregateFunctionUsedError);
        return expColumn;
    }

    public addGroupByColumn(): ExpressionBasedColumn {
        const aggColumn = this.createExpressionBasedColumn();
        this.groupByColumns.push(aggColumn);
        return aggColumn;
    }

    public getExpressions(): DataFlowExpression[] {
        const dataFlowExpressions: DataFlowExpression[] = super.getExpressions();
        this.groupByColumns.forEach((groupByColumn) => {
            if (groupByColumn instanceof ExpressionBasedColumn) {
                if (groupByColumn.dataFlowExpression) {
                    dataFlowExpressions.push(groupByColumn.dataFlowExpression);
                }
            }
        });

        return dataFlowExpressions;
    }

    protected updateInputTransformationCacheInternal(): void {
        super.updateInputTransformationCacheInternal();
        const availableColumns = convertColumnRefToDataFlowColumn(this.distinctInputColumnRefs);
        const availableArgumentsForGroupBy: IDataFlowArguments = {
            dataFlowColumns: availableColumns,
            dataFlowFunctions: DataFlowExpressionFunctions.ALL_FUNCTIONS,
            dataFlowParameters: convertParametersToArguments(this.dataflow.parameters),
            dataFlowTransientColumns: convertColumnRefToDataFlowColumn(this.transientColumnRefs),
            dataFlowCacheSinks: convertCacheSinksToArguments(this.dataflow.cacheSinks)
        };
        this.groupByColumns.forEach((groupByColumn) => {
            // Not updating the identifier for the pattern columns, for validation we need it.
            if (groupByColumn instanceof ExpressionBasedColumn) {
                if (groupByColumn.dataFlowExpression) {
                    if (GlobalVariables.validateDataFlowAPI) {
                        asyncUpdateIdentifiers(availableArgumentsForGroupBy, groupByColumn.dataFlowExpression, this);
                    } else {
                        updateIdentifiers(availableArgumentsForGroupBy, groupByColumn.dataFlowExpression);
                    }
                }
            }
        });
    }

    protected getAvailableFunctionsForExpressionColumns(): DataFlowFunctionArgument[] {
        return DataFlowExpressionFunctions.ALL_INLCUDING_AGGREGATE_FUNCTIONS;
    }
}
